import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiAlertTriangle, FiCalendar, FiMapPin, FiEdit2, FiTrash2 } from 'react-icons/fi';
import './Report.css';

const Report = () => {
  const navigate = useNavigate();
  const [reports, setReports] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch('https://api.aartian.online/reports', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch reports');
        }
        
        const data = await response.json();
        setReports(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchReports();
  }, []);

  const handleDelete = async (reportId) => {
    if (!window.confirm('Are you sure you want to delete this report?')) return;
    
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`https://api.aartian.online/reports/${reportId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to delete report');
      }
      
      setReports(reports.filter(report => report._id !== reportId));
    } catch (err) {
      setError(err.message);
    }
  };

  const getSeverityColor = (severity) => {
    switch (severity) {
      case 'high': return '#ff4444';
      case 'medium': return '#ffbb33';
      case 'low': return '#00C851';
      default: return '#2b2d42';
    }
  };

  return (
    <div className="report-container">
      <div className="report-header">
        <h1>Incident Reports</h1>
        <button 
          className="create-report-btn"
          onClick={() => navigate('/reports/create')}
        >
          + Create New Report
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {isLoading ? (
        <div className="loading-spinner">Loading reports...</div>
      ) : reports.length === 0 ? (
        <div className="no-reports">
          <FiAlertTriangle size={48} />
          <p>No reports found</p>
        </div>
      ) : (
        <div className="report-grid">
          {reports.map(report => (
            <div key={report._id} className="report-card">
              <div className="report-card-header">
                <h3>{report.title}</h3>
                <span 
                  className="severity-badge"
                  style={{ backgroundColor: getSeverityColor(report.severity) }}
                >
                  {report.severity}
                </span>
              </div>
              
              <p className="report-description">{report.description}</p>
              
              <div className="report-meta">
                <div className="meta-item">
                  <FiMapPin />
                  <span>{report.location}</span>
                </div>
                <div className="meta-item">
                  <FiCalendar />
                  <span>{new Date(report.createdAt).toLocaleDateString()}</span>
                </div>
              </div>
              
              <div className="report-actions">
                <button 
                  className="action-btn edit"
                  onClick={() => navigate(`/reports/edit/${report._id}`)}
                >
                  <FiEdit2 /> Edit
                </button>
                <button 
                  className="action-btn delete"
                  onClick={() => handleDelete(report._id)}
                >
                  <FiTrash2 /> Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Report;